import React from "react";
import { useApp } from "@/context/AppContext";

export const StatusBadge = ({ status }) => {
  const { t } = useApp();
  const map = { new: "chip-new", pitched: "chip-pitched", sold: "chip-sold" };
  const label = { new: t("statusNew"), pitched: t("statusPitched"), sold: t("statusSold") };
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${map[status] || "chip-new"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label[status] || status}
    </span>
  );
};
